'use strict';
define('betgamesIframePlayer',['betgamesPlayerAPI', 'errorHandler', 'translations', 'util'],
	(BGPlayerApi, errorHandler, T, Util) => {
		return (playerContainerID, partnerID) => {
			let activeGameID,
				playerContainer = document.getElementById(playerContainerID) || document.body,
		    playerIframe;

			const destroyIframe = () => {
					document.querySelectorAll('iframe').forEach((iframe) => {
						iframe.parentNode.removeChild(iframe);
					});
					playerIframe = undefined;
				},
				createIframe = (done, error) => {
					destroyIframe();
					const iframe = document.createElement('iframe'),
						// Iframe proxy URLs will be hosted on the same origin in 'betgames-player' path
						// If the screen is not hosted on HTTPS, default origin will be used instead
						origin = window.location.origin.startsWith('https://')
							? window.location.origin
							: 'https://games.advbet.com';

					iframe.src = `${origin}/betgames-player`;
					iframe.allow = 'autoplay; encrypted-media';
					iframe.onerror = () => {
						error('Cant create media frame');
					};
					iframe.onabort = () => {
						error('Cant create media frame');
					};

					playerContainer.appendChild(iframe);

					done(iframe);
				},
				playerConfig = (code, gameId, url, muted) => {
					return {
						param: { code, gameId },
						xhr: { url },
						playback: { showControls: false, muted }
					};
				},
				clear = () => {
					BGPlayerApi.destroy();
					destroyIframe();
					activeGameID = undefined;
				},
				setMuted = (muted) => {
					if (activeGameID) {
						BGPlayerApi.setMute(muted);
					}
				},
				init = (gameID, url, muted, gameData) => {
					let loaded = false;

					return new Promise((resolve, reject) => {
					// Destroy active player instance if source URLs are changed
						if (activeGameID && activeGameID !== gameID) {
							clear();
						}

						activeGameID = gameID;

						if (playerIframe) {
						// Player already initialized
							resolve();
							return;
						}

						// Initialize player iframe
						const promisifyIframe = new Promise((res, rej) => createIframe(res, rej));

						promisifyIframe
							.then((iframe) => {
								playerIframe = iframe;

								try {
									BGPlayerApi.setup({
										target: playerIframe,
										config: playerConfig(partnerID, gameID, url, muted)
									});

									BGPlayerApi.onReady(() => {
										loaded = true;
										setMuted(muted);
										resolve();
									});

									BGPlayerApi.onError((cause) => {
										clear();
										reject(cause.message);
									});

									// Reload and retry to load player if it's not loaded in 5 seconds
									setTimeout(() => {
										if (!loaded) {
											const duration = Util.videoStreamDurationLeft(gameData);

											if (duration > 0) {
												errorHandler.showError(T.translate('translate_err10'), 5000);
												clear();
												init(gameID, url, muted, gameData).then(resolve).catch(reject);
												return;
											}

											reject(new Error('Failed to load betgames-player'));
										}
									}, 5000);
								} catch (e) {
									reject(e);
								}
							})
							.catch((error) => {
								reject(error);
							});
					});
				},
				play = () => {
					return new Promise((resolve) => {
						resolve();
					});
				};

			return {
			// Initialize Betgames player for specified game
				init,

				// Set muted state for the player
				setMuted,

				// Not implemented because the player will run right after init()
				play,

				// Destroy currently running player
				clear
			};
		};
	});

